import React from 'react';
import { Input } from '../../components/ui/input';
import { User, Mail, Lock, Eye, EyeOff, ChevronDown } from 'lucide-react';
import countryCodes from './countryCodes';

/**
 * Email/password form fields shared by Sign In and Sign Up.
 * Pure presentational — all state is owned by the parent.
 */
const AuthFormFields = ({
  isLogin,
  formData,
  onChange,
  dialCode,
  onDialCodeChange,
  showPassword,
  onToggleShowPassword,
}) => {
  return (
    <>
      {!isLogin && (
        <div>
          <label className="block text-sm font-medium mb-1">Full Name <span className="text-red-500">*</span></label>
          <div className="relative">
            <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
            <Input name="full_name" value={formData.full_name} onChange={onChange} placeholder="Enter your full name" className="pl-10" required data-testid="auth-fullname" />
          </div>
        </div>
      )}

      {!isLogin && (
        <div>
          <label className="block text-sm font-medium mb-1">Referral Code <span className="text-gray-400">(optional)</span></label>
          <Input name="referral_code" value={formData.referral_code || ''} onChange={onChange} placeholder="Enter a referral code" className="uppercase" data-testid="auth-referral-code" />
        </div>
      )}

      <div>
        <label className="block text-sm font-medium mb-1">Email <span className="text-red-500">*</span></label>
        <div className="relative">
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
          <Input type="email" name="email" value={formData.email} onChange={onChange} placeholder="Enter your email" className="pl-10" required data-testid="auth-email" id="auth-email-input" />
        </div>
      </div>

      {!isLogin && (
        <div>
          <label className="block text-sm font-medium mb-1">Phone Number <span className="text-red-500">*</span></label>
          <div className="flex gap-0">
            <div className="relative">
              <select
                value={dialCode}
                onChange={(e) => onDialCodeChange(e.target.value)}
                className="h-10 pl-3 pr-7 border border-r-0 rounded-l-md bg-gray-50 text-sm appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                data-testid="auth-dial-code"
              >
                {countryCodes.map((c) => (
                  <option key={c.code} value={c.code}>
                    {c.code} {c.country}
                  </option>
                ))}
              </select>
              <ChevronDown className="absolute right-1.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-gray-400 pointer-events-none" />
            </div>
            <Input
              name="phone"
              type="tel"
              value={formData.phone}
              onChange={onChange}
              placeholder="Phone number"
              className="rounded-l-none flex-1"
              required
              data-testid="auth-phone"
            />
          </div>
        </div>
      )}

      <div>
        <label className="block text-sm font-medium mb-1">Password <span className="text-red-500">*</span></label>
        <div className="relative">
          <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
          <Input type={showPassword ? 'text' : 'password'} name="password" value={formData.password} onChange={onChange} placeholder="Enter your password" className="pl-10 pr-10" required minLength={6} data-testid="auth-password" />
          <button type="button" onClick={onToggleShowPassword} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
            {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </button>
        </div>
      </div>

      {!isLogin && (
        <div>
          <label className="block text-sm font-medium mb-1">Confirm Password <span className="text-red-500">*</span></label>
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
            <Input type={showPassword ? 'text' : 'password'} name="confirmPassword" value={formData.confirmPassword} onChange={onChange} placeholder="Confirm your password" className="pl-10" required={!isLogin} data-testid="auth-confirm-password" />
          </div>
        </div>
      )}
    </>
  );
};

export default AuthFormFields;
